(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__auRevealInit) return;
    window.__auRevealInit = true;
    var root = document.documentElement;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce || !('IntersectionObserver' in window)) return;
    root.classList.add('au-anim');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('au-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -5% 0px' });
    var arm = function () {
      document.querySelectorAll('.au-reveal:not(.au-in)').forEach(function (el) { io.observe(el); });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arm);
    else arm();
    // safety: if anything is still hidden after load, reveal it
    window.addEventListener('load', function () {
      setTimeout(function () {
        document.querySelectorAll('.au-reveal:not(.au-in)').forEach(function (el) {
          var r = el.getBoundingClientRect();
          if (r.top < (window.innerHeight || 800)) el.classList.add('au-in');
        });
      }, 200);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-shop-all"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(section) {
      var grid = section.querySelector('[data-csa-grid]');
      var cards = section.querySelectorAll('[data-csa-card]');
      var sidebar = section.querySelector('[data-csa-sidebar]');
      var drawer = section.querySelector('[data-csa-drawer]');
      var drawerBody = section.querySelector('[data-csa-drawer-body]');
      var openBtn = section.querySelector('[data-csa-open-drawer]');
      var closeBtns = section.querySelectorAll('[data-csa-close-drawer]');
      var emptyEl = section.querySelector('[data-csa-empty]');
      var visibleCounters = section.querySelectorAll('[data-csa-visible-count]');
      var resetBtns = section.querySelectorAll('[data-csa-reset]');
      var searchInput = section.querySelector('[data-csa-search]');
      var sortSelect = null; // sort dropdown removed
      var activeChipsEl = section.querySelector('[data-csa-active-chips]');

      // Mirror sidebar filters into the mobile drawer
      if (drawerBody && sidebar) {
        var clone = sidebar.cloneNode(true);
        clone.removeAttribute('data-csa-sidebar');
        clone.style.background = 'transparent';
        clone.style.padding = '0';
        clone.style.display = 'block';
        // Remove the original head/chips inside the clone (drawer has its own)
        var cloneHead = clone.querySelector('.csa-sidebar__head');
        if (cloneHead) cloneHead.remove();
        var cloneChips = clone.querySelector('.csa-active-chips');
        if (cloneChips) cloneChips.remove();
        drawerBody.appendChild(clone);
        // When a drawer checkbox toggles, enforce single-select + sync to sidebar
        drawerBody.addEventListener('change', function (e) {
          var cb = e.target;
          if (!cb.matches || !cb.matches('[data-csa-filter]')) return;
          enforceSingleSelect(cb);
          syncSidebarFromDrawer();
          applyFilters();
        });
      }

      // Enforce max-1 selection within the same group (uncheck siblings if a new one is checked)
      function enforceSingleSelect(activatedCb) {
        if (!activatedCb.checked) return;
        var group = activatedCb.closest('.csa-group');
        if (!group) return;
        var groupId = group.dataset.csaGroup;
        if (!groupId) return;
        // Uncheck all OTHER checkboxes in any group with same data-csa-group attr (sidebar + drawer copies)
        document.querySelectorAll('.csa-group[data-csa-group="' + groupId + '"]').forEach(function (g) {
          g.querySelectorAll('[data-csa-filter]').forEach(function (cb) {
            if (cb.dataset.csaTag !== activatedCb.dataset.csaTag) cb.checked = false;
          });
        });
      }

      // Mirror sidebar state INTO drawer copies (drawer → sidebar handled inline above)
      function syncDrawerFromSidebar() {
        if (!drawerBody) return;
        sidebar.querySelectorAll('[data-csa-filter]').forEach(function (cb) {
          var dcb = drawerBody.querySelector('[data-csa-filter][data-csa-tag="' + cb.dataset.csaTag + '"]');
          if (dcb) dcb.checked = cb.checked;
        });
      }
      function syncSidebarFromDrawer() {
        if (!drawerBody) return;
        drawerBody.querySelectorAll('[data-csa-filter]').forEach(function (cb) {
          var sb = sidebar.querySelector('[data-csa-filter][data-csa-tag="' + cb.dataset.csaTag + '"]');
          if (sb) sb.checked = cb.checked;
        });
      }

      function getActiveTags() {
        return Array.from(sidebar.querySelectorAll('[data-csa-filter]:checked'))
          .map(function (cb) { return { tag: cb.dataset.csaTag, label: cb.dataset.csaLabel }; });
      }

      function renderActiveChips(active) {
        if (!activeChipsEl) return;
        activeChipsEl.innerHTML = '';
        active.forEach(function (item) {
          var chip = document.createElement('span');
          chip.className = 'csa-chip';
          chip.innerHTML = '<span>' + item.label + '</span>' +
            '<button type="button" class="csa-chip__remove" aria-label="Remove" data-csa-remove="' + item.tag + '">' +
            '<svg viewBox="0 0 16 16" width="12" height="12" aria-hidden="true"><path d="M4 4l8 8M12 4l-8 8" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>' +
            '</button>';
          activeChipsEl.appendChild(chip);
        });
        activeChipsEl.querySelectorAll('[data-csa-remove]').forEach(function (btn) {
          btn.addEventListener('click', function () {
            var tag = btn.dataset.csaRemove;
            sidebar.querySelectorAll('[data-csa-filter][data-csa-tag="' + tag + '"]').forEach(function (cb) { cb.checked = false; });
            if (drawerBody) drawerBody.querySelectorAll('[data-csa-filter][data-csa-tag="' + tag + '"]').forEach(function (cb) { cb.checked = false; });
            applyFilters();
          });
        });
      }

      function applyFilters() {
        var active = getActiveTags();
        var search = (searchInput && searchInput.value || '').trim().toLowerCase();
        var visibleCount = 0;

        cards.forEach(function (card) {
          var tags = (card.dataset.csaTags || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean);
          var title = card.dataset.csaTitle || '';
          var matchesTags = active.length === 0 || active.every(function (a) { return tags.indexOf(a.tag) !== -1; });
          var matchesSearch = !search || title.indexOf(search) !== -1;
          var visible = matchesTags && matchesSearch;
          card.classList.toggle('is-hidden', !visible);
          if (visible) visibleCount++;
        });

        visibleCounters.forEach(function (el) { el.textContent = visibleCount; });
        if (emptyEl) emptyEl.hidden = visibleCount > 0;
        resetBtns.forEach(function (btn) { btn.hidden = active.length === 0 && !search; });
        renderActiveChips(active);

        // Update mobile filter button badge with active filter count
        var badgeEl = section.querySelector('[data-csa-active-count]');
        if (badgeEl) {
          if (active.length > 0) {
            badgeEl.textContent = active.length;
            badgeEl.removeAttribute('hidden');
          } else {
            badgeEl.textContent = '';
            badgeEl.setAttribute('hidden', '');
          }
        }
      }

      sidebar.querySelectorAll('[data-csa-filter]').forEach(function (cb) {
        cb.addEventListener('change', function () {
          enforceSingleSelect(cb);
          syncDrawerFromSidebar();
          applyFilters();
        });
      });
      resetBtns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          sidebar.querySelectorAll('[data-csa-filter]').forEach(function (cb) { cb.checked = false; });
          if (drawerBody) drawerBody.querySelectorAll('[data-csa-filter]').forEach(function (cb) { cb.checked = false; });
          if (searchInput) searchInput.value = '';
          applyFilters();
        });
      });
      if (searchInput) searchInput.addEventListener('input', applyFilters);

      if (openBtn) openBtn.addEventListener('click', function () {
        drawer.hidden = false;
        document.body.style.overflow = 'hidden';
        openBtn.setAttribute('aria-expanded', 'true');
      });
      closeBtns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          drawer.hidden = true;
          document.body.style.overflow = '';
          if (openBtn) openBtn.setAttribute('aria-expanded', 'false');
        });
      });

      // Auto-apply filter from URL hash (e.g. #filter=best-seller)
      function applyHashFilter() {
        var hash = (window.location.hash || '').replace(/^#/, '');
        if (!hash) return;
        var params = {};
        hash.split('&').forEach(function (kv) {
          var p = kv.split('=');
          if (p.length === 2) params[decodeURIComponent(p[0])] = decodeURIComponent(p[1]);
        });
        var wantTag = params['filter'];
        if (!wantTag) return;
        var cb = sidebar.querySelector('[data-csa-filter][data-csa-tag="' + wantTag + '"]');
        if (cb) {
          cb.checked = true;
          if (drawerBody) {
            var dcb = drawerBody.querySelector('[data-csa-filter][data-csa-tag="' + wantTag + '"]');
            if (dcb) dcb.checked = true;
          }
          applyFilters();
        }
      }

      // Initial state
      applyFilters();
      applyHashFilter();
      window.addEventListener('hashchange', applyHashFilter);
    }

    document.querySelectorAll('[data-shop-all]').forEach(init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-ncl"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(section) {
      // Moves the gallery to the image attached to the selected variant.
      // Assigned inside the gallery block below; no-op if the gallery is absent.
      let syncGalleryToImageId = function () {};
      let lastSyncedVariantId = null;

      // Gallery: swipeable slider + lightbox on tap, two-way thumb sync
      try {
        const slides = section.querySelector('[data-pdp-slides]');
        const thumbs = section.querySelectorAll('[data-pdp-thumb]');
        const slideButtons = section.querySelectorAll('[data-pdp-slide]');
        const lightbox = section.querySelector('[data-pdp-lightbox]');
        const lightboxTrack = section.querySelector('[data-pdp-lightbox-track]');
        const lightboxClose = section.querySelector('[data-pdp-lightbox-close]');

        function setActiveThumb(idx) {
          thumbs.forEach((b, i) => {
            b.classList.toggle('is-active', i === idx);
            b.setAttribute('aria-selected', i === idx ? 'true' : 'false');
          });
        }

        // Native lazy loading doesn't reliably fetch slides sitting far along a
        // horizontal scroller, which left the pack shots blank when jumped to.
        // Flipping loading to eager starts the fetch straight away.
        function forceLoadSlide(slide) {
          const img = slide && slide.querySelector('img');
          if (img && img.getAttribute('loading') === 'lazy') {
            img.setAttribute('loading', 'eager');
          }
        }

        function slideForImageId(imageId) {
          if (!imageId || !slides) return null;
          return slides.querySelector('[data-pdp-slide][data-pdp-image-id="' + imageId + '"]');
        }

        // Warm the variant-linked pack shots once the page goes idle, so changing
        // quantity shows the image immediately rather than an empty frame.
        function warmVariantSlides() {
          section.querySelectorAll('[data-pdp-variant][data-pdp-variant-image]').forEach((input) => {
            forceLoadSlide(slideForImageId(input.getAttribute('data-pdp-variant-image')));
          });
        }
        if ('requestIdleCallback' in window) {
          requestIdleCallback(warmVariantSlides, { timeout: 3000 });
        } else {
          setTimeout(warmVariantSlides, 2000);
        }

        // Variant → gallery sync. Jumps to the slide holding the variant's
        // featured image (e.g. the 2-bottle / 3-bottle pack shot). When the
        // variant has no image of its own, fall back to the first slide.
        syncGalleryToImageId = function (imageId) {
          if (!slides || !slides.children.length) return;
          let target = slideForImageId(imageId);
          if (!target) target = slides.children[0];
          const idx = Array.prototype.indexOf.call(slides.children, target);
          if (idx < 0) return;
          forceLoadSlide(target);
          // Jump instantly rather than smooth-scrolling: this track is
          // `scroll-snap-type: x mandatory`, and an in-flight smooth scroll can be
          // interrupted by a layout shift and then snapped back to the old slide.
          const settle = function () {
            slides.scrollTo({ left: target.offsetLeft, behavior: 'auto' });
            setActiveThumb(idx);
          };
          settle();
          // Re-assert on the next frame in case layout moved under us.
          requestAnimationFrame(settle);
        };

        // Thumb click → scroll main slider to matching index
        thumbs.forEach((btn, idx) => {
          btn.addEventListener('click', () => {
            if (slides && slides.children[idx]) {
              slides.scrollTo({
                left: slides.children[idx].offsetLeft,
                behavior: 'smooth'
              });
            }
            setActiveThumb(idx);
          });
        });

        // Main slider scroll → activate matching thumb
        if (slides) {
          let scrollDebounce;
          slides.addEventListener('scroll', () => {
            clearTimeout(scrollDebounce);
            scrollDebounce = setTimeout(() => {
              const w = slides.clientWidth;
              if (w > 0) {
                const idx = Math.round(slides.scrollLeft / w);
                setActiveThumb(idx);
              }
            }, 80);
          });
        }

        // Slide click → open lightbox at that index
        slideButtons.forEach((btn) => {
          btn.addEventListener('click', () => {
            if (!lightbox) return;
            const idx = parseInt(btn.getAttribute('data-pdp-slide-index') || '0', 10);
            try { lightbox.showModal(); }
            catch (_) { lightbox.setAttribute('open', ''); }
            requestAnimationFrame(() => {
              if (lightboxTrack && lightboxTrack.children[idx]) {
                lightboxTrack.scrollLeft = lightboxTrack.children[idx].offsetLeft;
              }
            });
          });
        });

        // Lightbox prev/next arrow navigation
        const lightboxPrev = section.querySelector('[data-pdp-lightbox-prev]');
        const lightboxNext = section.querySelector('[data-pdp-lightbox-next]');
        function lightboxScrollBy(direction) {
          if (!lightboxTrack) return;
          const w = lightboxTrack.clientWidth;
          if (w <= 0) return;
          const total = lightboxTrack.children.length;
          const currentIdx = Math.round(lightboxTrack.scrollLeft / w);
          let targetIdx = currentIdx + direction;
          if (targetIdx < 0) targetIdx = total - 1;
          if (targetIdx >= total) targetIdx = 0;
          if (lightboxTrack.children[targetIdx]) {
            lightboxTrack.scrollTo({
              left: lightboxTrack.children[targetIdx].offsetLeft,
              behavior: 'smooth'
            });
          }
        }
        if (lightboxPrev) {
          lightboxPrev.addEventListener('click', (e) => {
            e.stopPropagation();
            lightboxScrollBy(-1);
          });
        }
        if (lightboxNext) {
          lightboxNext.addEventListener('click', (e) => {
            e.stopPropagation();
            lightboxScrollBy(1);
          });
        }

        // Lightbox close (button + backdrop click)
        if (lightbox) {
          function closeLightbox() {
            try { lightbox.close(); }
            catch (_) { lightbox.removeAttribute('open'); }
          }
          if (lightboxClose) lightboxClose.addEventListener('click', closeLightbox);
          lightbox.addEventListener('click', (e) => {
            if (e.target === lightbox) closeLightbox();
          });
        }
      } catch (e) { console.warn('[pdp] gallery error', e); }

      const form = section.querySelector('[data-pdp-form]');
      if (!form) { console.warn('[pdp] no form'); return; }

      let variants = [];
      try {
        const variantsScript = section.querySelector('[data-pdp-variants-json]');
        if (variantsScript) {
          variants = JSON.parse(variantsScript.textContent.trim());
        }
      } catch (e) { console.warn('[pdp] variants parse error', e); }

      const ctaEl = form.querySelector('[data-pdp-cta]');
      const currencyEl = section.querySelector('[data-pdp-currency]');
      const currency = (currencyEl && currencyEl.getAttribute('data-pdp-currency')) || 'USD';
      const freeShipCents = parseInt((currencyEl && currencyEl.getAttribute('data-pdp-free-ship-cents')) || '3000', 10);

      function formatMoney(cents) {
        if (cents == null || isNaN(cents)) return '';
        const dollars = cents / 100;
        try {
          return new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: currency,
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
          }).format(dollars);
        } catch (e) {
          return '$' + dollars.toFixed(2);
        }
      }

      function findVariantById(id) {
        return variants.find((v) => String(v.id) === String(id));
      }

      function getSelectedVariant() {
        const checked = form.querySelector('[data-pdp-variant]:checked');
        if (!checked) return variants[0] || null;
        return findVariantById(checked.value);
      }

      function getAllocationForVariant(v, planId) {
        if (!v || !planId || !v.selling_plan_allocations) return null;
        return v.selling_plan_allocations.find((a) => String(a.selling_plan_id) === String(planId));
      }

      // Save initial CTA label
      if (ctaEl) ctaEl.dataset.label = ctaEl.textContent.trim();

      const planSelect = form.querySelector('[data-ppo-plan]');
      const ppoExtra = form.querySelector('[data-ppo-extra]');

      function update() {
        const v = getSelectedVariant();
        if (!v) return;

        // Show the selected variant's image. Only runs when the variant actually
        // changed, so quantity/subscription updates never yank the gallery away
        // from an image the customer scrolled to themselves.
        if (String(v.id) !== String(lastSyncedVariantId)) {
          const isInitialSync = lastSyncedVariantId === null;
          lastSyncedVariantId = v.id;
          const checkedInput = form.querySelector('[data-pdp-variant]:checked');
          const variantImageId = checkedInput
            ? checkedInput.getAttribute('data-pdp-variant-image')
            : null;
          // On first paint only move when the variant actually has its own image,
          // so the default first-slide render is left alone.
          if (!isInitialSync || variantImageId) {
            syncGalleryToImageId(variantImageId);
          }
        }

        // Current quantity (for multiplied price display)
        const qtyInputForUpdate = form.querySelector('[data-pdp-qty]');
        const qty = qtyInputForUpdate ? Math.max(1, parseInt(qtyInputForUpdate.value, 10) || 1) : 1;

        // Determine purchase choice
        const ppoChecked = form.querySelector('[data-ppo]:checked');
        const isSubscribe = ppoChecked && ppoChecked.value === 'subscribe';

        // Toggle the extra panel (frequency + perks) - only show if subscribe selected
        if (ppoExtra) {
          if (isSubscribe) {
            ppoExtra.removeAttribute('hidden');
          } else {
            ppoExtra.setAttribute('hidden', '');
          }
        }

        // Enable/disable selling_plan select so form submission is correct
        if (planSelect) {
          planSelect.disabled = !isSubscribe;
        }

        function buildPriceHTML(comparePrice, salePrice) {
          let main = '';
          const onSale = comparePrice != null && comparePrice > salePrice;
          if (onSale) {
            main += '<span class="ppo-price-compare"><span class="visually-hidden">Regular price</span> ' + formatMoney(comparePrice) + '</span>';
          }
          main += '<span class="ppo-price-amount">' + (onSale ? '<span class="visually-hidden">Sale price</span> ' : '') + formatMoney(salePrice) + '</span>';
          let html = '<span class="ppo-price__main">' + main + '</span>';
          if (salePrice != null && salePrice >= freeShipCents) {
            html += '<span class="ppo-price-shipping">FREE SHIPPING</span>';
          }
          return html;
        }

        // Update one-time price (multiplied by qty)
        const otPriceEl = form.querySelector('[data-ppo-ot-price]');
        if (otPriceEl) {
          const otCompare = v.compare_at_price ? v.compare_at_price * qty : null;
          const otSale = v.price * qty;
          otPriceEl.innerHTML = buildPriceHTML(otCompare, otSale);
        }

        // Update subscribe price + label with discount %
        const planId = planSelect ? planSelect.value : '';
        const alloc = getAllocationForVariant(v, planId);
        const subPriceEl = form.querySelector('[data-ppo-sub-price]');
        const subLabelEl = form.querySelector('[data-ppo-sub-label]');
        let subPct = 0;
        if (alloc && alloc.price != null) {
          if (subPriceEl) {
            const subCompare = alloc.compare_at_price ? alloc.compare_at_price * qty : null;
            const subSale = alloc.price * qty;
            subPriceEl.innerHTML = buildPriceHTML(subCompare, subSale);
          }
          if (alloc.compare_at_price && alloc.compare_at_price > alloc.price) {
            subPct = Math.round(((alloc.compare_at_price - alloc.price) / alloc.compare_at_price) * 100);
          }
        } else if (subPriceEl) {
          const subCompare = v.compare_at_price ? v.compare_at_price * qty : null;
          const subSale = v.price * qty;
          subPriceEl.innerHTML = buildPriceHTML(subCompare, subSale);
        }
        if (subLabelEl) {
          subLabelEl.textContent = subPct > 0 ? 'Subscribe & Save ' + subPct + '%' : 'Subscribe & Save';
        }

        // CTA: toggle between in-stock button and BIS (Notify When Available) wrapper
        const bisWrap = form.querySelector('[data-pdp-bis-wrap]');
        if (ctaEl) {
          if (v.available) {
            ctaEl.disabled = false;
            ctaEl.classList.remove('pdp-hero__add-to-cart--disabled');
            ctaEl.textContent = isSubscribe
              ? (ctaEl.dataset.subscribeLabel || 'Subscribe Now')
              : (ctaEl.dataset.onetimeLabel || ctaEl.dataset.label || 'Add To Cart');
            ctaEl.style.display = '';
            if (bisWrap) bisWrap.setAttribute('hidden', '');
            form.setAttribute('data-pdp-state', 'instock');
          } else {
            ctaEl.style.display = 'none';
            if (bisWrap) {
              bisWrap.removeAttribute('hidden');
              const bisComp = bisWrap.querySelector('klaviyo-bis-component');
              if (bisComp) {
                bisComp.setAttribute('data-variant-id', String(v.id));
                const variantLine = bisComp.querySelector('.ncl-bis__product-variant');
                if (variantLine) {
                  if (v.title && v.title !== 'Default Title') {
                    variantLine.textContent = v.title;
                    variantLine.style.display = '';
                  } else {
                    variantLine.textContent = '';
                    variantLine.style.display = 'none';
                  }
                }
              }
            }
            form.setAttribute('data-pdp-state', 'oos');
            // Update the OOS price block
            const oosAmount = form.querySelector('[data-pdp-oos-amount]');
            const oosCompare = form.querySelector('[data-pdp-oos-compare]');
            if (oosAmount) oosAmount.textContent = formatMoney(v.price);
            if (oosCompare) {
              if (v.compare_at_price && v.compare_at_price > v.price) {
                oosCompare.textContent = formatMoney(v.compare_at_price);
                oosCompare.removeAttribute('hidden');
              } else {
                oosCompare.textContent = '';
                oosCompare.setAttribute('hidden', '');
              }
            }
          }
        }

        // Highlight selected cards
        form.querySelectorAll('.pdp-hero__qsel-card').forEach((card) => {
          const input = card.querySelector('[data-pdp-variant]');
          card.classList.toggle('is-active', input && input.checked);
        });
        form.querySelectorAll('.ppo-row').forEach((row) => {
          const input = row.querySelector('[data-ppo]');
          row.classList.toggle('is-active', input && input.checked);
        });
      }

      try {
        form.querySelectorAll('[data-pdp-variant]').forEach((r) => {
          r.addEventListener('change', update);
        });
        form.querySelectorAll('[data-ppo]').forEach((r) => {
          r.addEventListener('change', update);
        });
        if (planSelect) planSelect.addEventListener('change', update);
        update();
      } catch (e) { console.warn('[pdp] update wiring error', e); }

      // ===== Quantity picker (inline with CTA) =====
      try {
        const qtyInput = form.querySelector('[data-pdp-qty]');
        const qtyBtns = form.querySelectorAll('[data-pdp-qty-action]');
        if (qtyInput) {
          qtyBtns.forEach((btn) => {
            btn.addEventListener('click', () => {
              const action = btn.getAttribute('data-pdp-qty-action');
              let v = parseInt(qtyInput.value, 10) || 1;
              if (action === 'inc') v = Math.min(99, v + 1);
              else if (action === 'dec') v = Math.max(1, v - 1);
              qtyInput.value = v;
              if (typeof update === 'function') update();
            });
          });
          qtyInput.addEventListener('change', () => {
            let v = parseInt(qtyInput.value, 10) || 1;
            if (v < 1) v = 1;
            if (v > 99) v = 99;
            qtyInput.value = v;
            if (typeof update === 'function') update();
          });
        }
      } catch (e) { console.warn('[pdp] qty error', e); }

      // ===== Hero CTA: AJAX add-to-cart + open drawer =====
      // The native form submit is blocked here because a hidden required Klaviyo
      // BIS <input type="email"> invalidates the form. AJAX add bypasses HTML
      // validation and gives the same drawer UX as the sticky bar button.
      try {
        if (ctaEl && !ctaEl.dataset.heroAddBound) {
          ctaEl.dataset.heroAddBound = '1';
          ctaEl.addEventListener('click', async function (e) {
            e.preventDefault();
            if (ctaEl.disabled) return;
            const fd = new FormData(form);
            const variantId = fd.get('id');
            if (!variantId) return;
            const qty = parseInt(fd.get('quantity') || '1', 10) || 1;
            const sellingPlan = fd.get('selling_plan');
            const body = { id: variantId, quantity: qty };
            if (sellingPlan) body.selling_plan = sellingPlan;
            const originalText = ctaEl.textContent;
            ctaEl.disabled = true;
            ctaEl.textContent = 'Adding…';
            try {
              const addResp = await fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                body: JSON.stringify(body)
              });
              if (!addResp.ok) {
                const errBody = await addResp.json().catch(() => ({}));
                throw new Error(errBody.description || 'Add to cart failed');
              }
              const drawer = document.querySelector('cart-drawer-component');
              const sectionIds = [];
              if (drawer) {
                const s = drawer.closest('[id^="shopify-section-"]');
                if (s) sectionIds.push(s.id.replace('shopify-section-', ''));
              }
              document.querySelectorAll('cart-icon-component, [class*="cart-icon"], cart-bubble').forEach((el) => {
                const s = el.closest && el.closest('[id^="shopify-section-"]');
                if (s) {
                  const id = s.id.replace('shopify-section-', '');
                  if (sectionIds.indexOf(id) === -1) sectionIds.push(id);
                }
              });
              const [sections, cart] = await Promise.all([
                sectionIds.length ? fetch('/?sections=' + sectionIds.join(',')).then((r) => r.json()) : Promise.resolve({}),
                fetch('/cart.js').then((r) => r.json())
              ]);
              document.dispatchEvent(new CustomEvent('cart:update', {
                bubbles: true,
                detail: { resource: cart, sourceId: 'pdp-hero-cta', data: { source: 'pdp-hero-cta', itemCount: cart.item_count, sections: sections } }
              }));
              if (drawer && typeof drawer.showDialog === 'function') drawer.showDialog();
              else if (drawer && typeof drawer.open === 'function') drawer.open();
            } catch (err) {
              console.error('[pdp-hero] add error', err);
              ctaEl.textContent = 'Try again';
              setTimeout(function () { ctaEl.textContent = originalText; }, 2000);
              return;
            } finally {
              ctaEl.disabled = false;
            }
            ctaEl.textContent = originalText;
          });
        }
      } catch (e) { console.warn('[pdp] hero cta error', e); }
    }

    // ===== Sticky Add-to-Cart Bar =====
    function initSticky() {
      const bar = document.querySelector('[data-pdp-sticky-bar]');
      const mainCta = document.querySelector('[data-pdp-cta]');
      const stickyBtn = bar ? bar.querySelector('[data-pdp-sticky-btn]') : null;
      const stickyPrice = bar ? bar.querySelector('[data-pdp-sticky-price]') : null;
      const stickyCompare = bar ? bar.querySelector('[data-pdp-sticky-compare]') : null;
      const form = document.querySelector('[data-pdp-form]');
      if (!bar || !mainCta || !stickyBtn || !form) return;

      bar.removeAttribute('hidden');

      // NCL - Reviews link smooth scroll to Stamped widget (robust against late hydration)
      document.addEventListener('click', function (ev) {
        const link = ev.target && ev.target.closest && ev.target.closest('[data-pdp-reviews-link]');
        if (!link) return;
        const target = document.getElementById('stamped-main-widget') || document.querySelector('.ncl-stamped');
        if (!target) return;
        ev.preventDefault();
        const rect = target.getBoundingClientRect();
        const top = window.pageYOffset + rect.top - 100; // 100px header offset
        window.scrollTo({ top: top, behavior: 'smooth' });
      });

      // Show/hide on scroll using IntersectionObserver
      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            const visible = !entry.isIntersecting && entry.boundingClientRect.top < 0;
            bar.setAttribute('data-show', visible ? 'true' : 'false');
            // Toggle body class so CSS can push the rewards launcher up
            document.body.classList.toggle('pdp-sticky-active', visible);
          });
        }, { threshold: 0, rootMargin: '0px 0px -10% 0px' });
        observer.observe(mainCta);
      }

      const onetimeRow = form.querySelector('[data-ppo-row="onetime"]');
      const subscribeRow = form.querySelector('[data-ppo-row="subscribe"]');

      // Sync price + button label with main CTA state
      function syncSticky() {
        // Determine which purchase type row is active
        const isSubscribe = subscribeRow && subscribeRow.classList.contains('is-active');
        const isOnetime = onetimeRow && onetimeRow.classList.contains('is-active');

        // Read the matching price block's amount
        let priceText = '';
        const priceBlock = isSubscribe
          ? form.querySelector('[data-ppo-sub-price]')
          : isOnetime
            ? form.querySelector('[data-ppo-ot-price]')
            : null;
        let compareText = '';
        if (priceBlock) {
          const amount = priceBlock.querySelector('.ppo-price-amount');
          if (amount) priceText = amount.textContent.trim();
          const compare = priceBlock.querySelector('.ppo-price-compare');
          if (compare) compareText = compare.textContent.trim();
        }
        // Fallback: legacy data-pdp-price element
        if (!priceText) {
          const fallback = form.querySelector('[data-pdp-price]');
          if (fallback) priceText = fallback.textContent.trim();
        }
        if (priceText && stickyPrice) stickyPrice.textContent = priceText;
        if (stickyCompare) {
          if (compareText) {
            stickyCompare.textContent = compareText;
            stickyCompare.removeAttribute('hidden');
          } else {
            stickyCompare.textContent = '';
            stickyCompare.setAttribute('hidden', '');
          }
        }

        // Button label: mirror main CTA - but if main CTA is hidden (OOS), become a BIS trigger
        const bisWrap2 = form.querySelector('[data-pdp-bis-wrap]');
        const isOOS = mainCta.style.display === 'none' && bisWrap2 && !bisWrap2.hasAttribute('hidden');
        if (isOOS) {
          stickyBtn.textContent = 'Notify When Available';
          stickyBtn.disabled = false;
          stickyBtn.dataset.bisMode = 'true';
        } else {
          const mainText = (mainCta.textContent || '').trim();
          if (mainText) stickyBtn.textContent = mainText;
          stickyBtn.disabled = mainCta.disabled === true;
          stickyBtn.dataset.bisMode = 'false';
        }
      }

      form.addEventListener('change', () => setTimeout(syncSticky, 60));
      form.addEventListener('click', () => setTimeout(syncSticky, 80));

      if ('MutationObserver' in window) {
        const mo = new MutationObserver(syncSticky);
        mo.observe(mainCta, { childList: true, characterData: true, subtree: true, attributes: true, attributeFilter: ['disabled'] });

        ['[data-ppo-ot-price]', '[data-ppo-sub-price]', '[data-pdp-price]'].forEach((sel) => {
          const el = form.querySelector(sel);
          if (el) new MutationObserver(syncSticky).observe(el, { childList: true, characterData: true, subtree: true });
        });

        [onetimeRow, subscribeRow].forEach((row) => {
          if (row) new MutationObserver(syncSticky).observe(row, { attributes: true, attributeFilter: ['class'] });
        });
      }

      syncSticky();

      // Sticky button - AJAX add to cart + open drawer (mirrors cart-products.liquid pattern)
      stickyBtn.addEventListener('click', async (e) => {
        e.preventDefault();
        if (stickyBtn.disabled) return;

        // BIS mode: open the back-in-stock modal of the visible BIS component
        if (stickyBtn.dataset.bisMode === 'true') {
          const bisTrigger = form.querySelector('[data-pdp-bis-wrap] [data-bis-open]');
          if (bisTrigger) { bisTrigger.click(); return; }
        }

        // Build add-to-cart body from form state (variant + qty + selling_plan if subscribe)
        const fd = new FormData(form);
        const variantId = fd.get('id');
        if (!variantId) return;
        const qty = parseInt(fd.get('quantity') || '1', 10) || 1;
        const sellingPlan = fd.get('selling_plan');
        const body = { id: variantId, quantity: qty };
        if (sellingPlan) body.selling_plan = sellingPlan;

        const originalText = stickyBtn.textContent;
        stickyBtn.disabled = true;
        stickyBtn.textContent = 'Adding…';

        try {
          // 1. Add to cart
          const addResp = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify(body)
          });
          if (!addResp.ok) {
            const errBody = await addResp.json().catch(() => ({}));
            throw new Error(errBody.description || 'Add to cart failed');
          }

          // 2. Find cart drawer + cart icon section IDs for refresh
          const drawer = document.querySelector('cart-drawer-component');
          const sectionIds = [];
          if (drawer) {
            const s = drawer.closest('[id^="shopify-section-"]');
            if (s) sectionIds.push(s.id.replace('shopify-section-', ''));
          }
          document.querySelectorAll('cart-icon-component, [class*="cart-icon"], cart-bubble').forEach((el) => {
            const s = el.closest && el.closest('[id^="shopify-section-"]');
            if (s) {
              const id = s.id.replace('shopify-section-', '');
              if (sectionIds.indexOf(id) === -1) sectionIds.push(id);
            }
          });

          // 3. Fetch updated sections + cart
          const [sections, cart] = await Promise.all([
            sectionIds.length
              ? fetch('/?sections=' + sectionIds.join(',')).then((r) => r.json())
              : Promise.resolve({}),
            fetch('/cart.js').then((r) => r.json())
          ]);

          // 4. Dispatch cart:update for Horizon's morph system
          document.dispatchEvent(new CustomEvent('cart:update', {
            bubbles: true,
            detail: {
              resource: cart,
              sourceId: 'pdp-sticky-bar',
              data: {
                source: 'pdp-sticky-bar',
                itemCount: cart.item_count,
                sections: sections
              }
            }
          }));

          // 5. Open the cart drawer
          if (drawer && typeof drawer.showDialog === 'function') drawer.showDialog();
          else if (drawer && typeof drawer.open === 'function') drawer.open();
        } catch (err) {
          console.error('[pdp-sticky] add error', err);
          stickyBtn.textContent = 'Try again';
          setTimeout(() => { stickyBtn.textContent = originalText; }, 2000);
          return;
        } finally {
          stickyBtn.disabled = false;
        }
        stickyBtn.textContent = originalText;
      });
    }

    initSticky();

    // ===== Pair-it-with horizontal scroller arrows =====
    function initPairArrows() {
      document.querySelectorAll('[data-pdp-pair]').forEach((pair) => {
        const track = pair.querySelector('[data-pdp-pair-track]');
        const prev = pair.querySelector('[data-pdp-pair-prev]');
        const next = pair.querySelector('[data-pdp-pair-next]');
        if (!track || !prev || !next) return;

        function step() {
          const card = track.querySelector('.pdp-hero__pair-card');
          if (!card) return Math.max(track.clientWidth - 40, 200);
          const cardW = card.getBoundingClientRect().width;
          const gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || '12') || 12;
          return cardW + gap;
        }

        function updateButtons() {
          const max = track.scrollWidth - track.clientWidth - 1;
          if (max <= 0) {
            prev.setAttribute('hidden', '');
            next.setAttribute('hidden', '');
            return;
          }
          if (track.scrollLeft <= 1) prev.setAttribute('hidden', ''); else prev.removeAttribute('hidden');
          if (track.scrollLeft >= max) next.setAttribute('hidden', ''); else next.removeAttribute('hidden');
        }

        prev.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
        next.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));
        track.addEventListener('scroll', updateButtons, { passive: true });
        window.addEventListener('resize', updateButtons);
        updateButtons();
        // Re-check after fonts/images load shift layout
        setTimeout(updateButtons, 200);
      });
    }
    initPairArrows();
    document.addEventListener('shopify:section:load', initPairArrows);

    document.querySelectorAll('[data-pdp-section]').forEach(init);
    document.addEventListener('shopify:section:load', (e) => {
      const s = e.target.querySelector('[data-pdp-section]');
      if (s) init(s);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-quality-safety"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(section) {
      var track = section.querySelector('[data-qs-track]');
      var prev = section.querySelector('[data-qs-prev]');
      var next = section.querySelector('[data-qs-next]');
      if (!track || !prev || !next) return;
      function step(dir) {
        var card = track.querySelector('.qs-reviews__card');
        if (!card) return;
        var w = card.getBoundingClientRect().width + 16;
        track.scrollBy({ left: dir * w, behavior: 'smooth' });
      }
      prev.addEventListener('click', function () { step(-1); });
      next.addEventListener('click', function () { step(1); });
    }
    document.querySelectorAll('[data-qs-reviews]').forEach(init);
    document.addEventListener('shopify:section:load', function (e) {
      var s = e.target.querySelector('[data-qs-reviews]');
      if (s) init(s);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pair-it-with"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    function openCartDrawer() {
      const drawer = document.querySelector('cart-drawer-component');
      if (drawer) {
        if (typeof drawer.showDialog === 'function') return drawer.showDialog();
        if (typeof drawer.open === 'function') return drawer.open();
        if (typeof drawer.show === 'function') return drawer.show();
      }
      document.dispatchEvent(new CustomEvent('cart:open', { bubbles: true }));
    }

    async function fetchCart() {
      const r = await fetch(root + 'cart.js', { headers: { 'Accept': 'application/json' } });
      return r.ok ? r.json() : null;
    }

    function setupForm(form) {
      if (form.dataset.piwBound === '1') return;
      form.dataset.piwBound = '1';
      form.addEventListener('submit', async (e) => {
        e.preventDefault();
        const btn = form.querySelector('button[type="submit"]');
        if (!btn || btn.disabled) return;
        const original = btn.textContent;
        btn.disabled = true;
        btn.textContent = 'Adding…';

        try {
          // 1. POST to /cart/add.js
          const addRes = await fetch(root + 'cart/add.js', {
            method: 'POST',
            body: new FormData(form),
            headers: { 'Accept': 'application/json' }
          });
          const addData = await addRes.json();
          if (!addRes.ok) throw new Error(addData.description || addData.message || 'Add failed');

          // 2. GET updated cart so the drawer can render the new state
          const cart = await fetchCart();

          // 3. Dispatch Horizon's cart:update event (matches ThemeEvents.cartUpdate)
          document.dispatchEvent(new CustomEvent('cart:update', {
            bubbles: true,
            detail: {
              resource: cart,
              sourceId: 'pair-it-with',
              data: {
                source: 'pair-it-with',
                productId: addData.product_id,
                variantId: addData.variant_id,
                itemCount: cart ? cart.item_count : null
              }
            }
          }));

          // 4. Open the drawer
          openCartDrawer();

          btn.textContent = 'Added ✓';
          setTimeout(() => { btn.textContent = original; btn.disabled = false; }, 1500);
        } catch (err) {
          console.warn('[piw] cart add error', err);
          btn.textContent = 'Try again';
          setTimeout(() => { btn.textContent = original; btn.disabled = false; }, 2000);
        }
      });
    }

    function init(rootEl) {
      (rootEl || document).querySelectorAll('.piw__form').forEach(setupForm);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => init(document));
    } else {
      init(document);
    }
    document.addEventListener('shopify:section:load', (e) => init(e.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["presale-waitlist"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('a[href="#ashwa-waitlist-form"]');
      if (!trigger) return;
      var target = document.getElementById('ashwa-waitlist-form');
      if (!target) return;
      e.preventDefault();
      var y = target.getBoundingClientRect().top + window.scrollY - 110;
      window.scrollTo({ top: y < 0 ? 0 : y, behavior: 'smooth' });
      var input = target.querySelector('input[type="email"]');
      if (input) {
        window.setTimeout(function () {
          try { input.focus({ preventScroll: true }); } catch (err) {}
        }, 460);
      }
    });

    // Add waitlist signups directly to the Klaviyo list (in addition to the
    // Shopify customer/tag created by the native form above).
    var STORAGE_KEY = 'pfAshwaWaitlistEmail';

    function captureEmail(form) {
      var input = form.querySelector('input[type="email"]');
      if (input && input.value) {
        try { sessionStorage.setItem(STORAGE_KEY, input.value); } catch (err) {}
      }
    }

    document.querySelectorAll('#ashwa-waitlist-form form, #ashwa-waitlist-form-2 form').forEach(function (form) {
      form.addEventListener('submit', function () { captureEmail(form); });
    });

    var pfRoot = document.querySelector('.pf[data-klaviyo-list-id]');
    var hasSuccess = document.querySelector('.pf-form__success');
    if (pfRoot && hasSuccess) {
      var storedEmail = null;
      try { storedEmail = sessionStorage.getItem(STORAGE_KEY); } catch (err) {}
      var publicKey = pfRoot.getAttribute('data-klaviyo-public-key');
      var listId = pfRoot.getAttribute('data-klaviyo-list-id');
      if (storedEmail && publicKey && listId) {
        fetch('https://a.klaviyo.com/client/subscriptions?company_id=' + encodeURIComponent(publicKey), {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            revision: '2024-10-15'
          },
          body: JSON.stringify({
            data: {
              type: 'subscription',
              attributes: {
                profile: {
                  data: {
                    type: 'profile',
                    attributes: { email: storedEmail }
                  }
                }
              },
              relationships: {
                list: { data: { type: 'list', id: listId } }
              }
            }
          })
        }).catch(function () {});
        try { sessionStorage.removeItem(STORAGE_KEY); } catch (err) {}
      }
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-cards-grid"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initFilters(section) {
      var filters = section.querySelectorAll('[data-pcg-filter]');
      var cards = section.querySelectorAll('[data-pcg-card]');
      if (filters.length === 0) return;

      function activate(value, showAll, hasCollection) {
        filters.forEach(function (btn) {
          var isMatch = btn.getAttribute('data-pcg-filter') === value;
          btn.classList.toggle('is-active', isMatch);
          btn.setAttribute('aria-selected', isMatch ? 'true' : 'false');
        });
        cards.forEach(function (card) {
          var fromCollection = card.hasAttribute('data-pcg-from-collection');
          var raw = card.getAttribute('data-pcg-categories') || '';
          var cats = raw.split(',').map(function (c) { return c.trim(); }).filter(Boolean);
          var matchesValue = cats.indexOf(value) !== -1;

          if (showAll) {
            // "Show all" (e.g. Best Sellers) → manual cards only
            card.classList.toggle('is-hidden', fromCollection);
          } else if (hasCollection) {
            // Tab has a collection assigned → show ONLY collection cards for this tab
            card.classList.toggle('is-hidden', !(fromCollection && matchesValue));
          } else {
            // Manual-only filter tab → match by categories
            card.classList.toggle('is-hidden', !matchesValue);
          }
        });
      }

      filters.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var value = btn.getAttribute('data-pcg-filter');
          var showAll = btn.getAttribute('data-pcg-show-all') === 'true';
          var hasCollection = btn.getAttribute('data-pcg-has-collection') === 'true';
          activate(value, showAll, hasCollection);
        });
      });

      // Apply default state on load (the active filter button)
      var active = section.querySelector('[data-pcg-filter].is-active');
      if (active) {
        var value = active.getAttribute('data-pcg-filter');
        var showAll = active.getAttribute('data-pcg-show-all') === 'true';
        var hasCollection = active.getAttribute('data-pcg-has-collection') === 'true';
        activate(value, showAll, hasCollection);
      }
    }

    function init() {
      document.querySelectorAll('.pcg').forEach(initFilters);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    // Re-init for theme editor (sections are reloaded on edit)
    document.addEventListener('shopify:section:load', function (e) {
      var section = e.target.querySelector('.pcg');
      if (section) initFilters(section);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-faq"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initSearch(section) {
      var input = section.querySelector('[data-pfaq-search]');
      var items = section.querySelectorAll('[data-pfaq-item]');
      var emptyEl = section.querySelector('[data-pfaq-empty]');
      if (!input) return;
      input.addEventListener('input', function () {
        var q = (input.value || '').trim().toLowerCase();
        var visibleCount = 0;
        items.forEach(function (it) {
          var summary = it.querySelector('summary');
          var body = it.querySelector('.ncl-pfaq__a');
          var hay = ((summary ? summary.textContent : '') + ' ' + (body ? body.textContent : '')).toLowerCase();
          var matches = q === '' || hay.indexOf(q) !== -1;
          it.classList.toggle('is-hidden', !matches);
          if (matches) visibleCount++;
          // Auto-expand items with matches when searching
          if (q && matches) it.setAttribute('open', '');
          else if (!q) it.removeAttribute('open');
        });
        if (emptyEl) emptyEl.hidden = visibleCount > 0;
      });
    }
    document.querySelectorAll('.section-product-faq, .ncl-pfaq').forEach(function (s) {
      var section = s.closest('section') || s;
      initSearch(section);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
